import React from 'react';
import {
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { gridSpacing } from '../../../../common/themes/constants';
import ReviewCardGroup from '../EnrollClinic/ReviewInformation';

export default function ClinicDetails({ data, onEditClinic }) {
  return (
    <Card>
      <CardContent>
        <Grid container
          direction="column"
          spacing={gridSpacing}>
          <ReviewCardGroup title="Clinic Details" data={data} onEditGroup={onEditClinic} />
        </Grid>
      </CardContent>
    </Card>
  );
}
